<template>
  <el-collapse-item name="1">
    <template slot="title">
      Postagens&nbsp;<el-tag>{{ tableList.length }}</el-tag>
    </template>
    <el-table :data="tableList" size="small" stripe>
      <el-table-column sortable prop="tag" :label="$t('etiqueta')" />
      <el-table-column sortable prop="service" :label="$t('servico')" />
      <el-table-column sortable prop="name" :label="$t('destinatario')" />
      <el-table-column sortable prop="sourceZicode" :label="$t('cep-origem')" />
      <el-table-column sortable prop="deliveryZicode" :label="$t('cep-destino')" />
      <el-table-column sortable prop="value" :label="$t('valor')">
        <template slot-scope="scope">
          {{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}
        </template>
      </el-table-column>
      <el-table-column width="80" align="right">
        <template slot-scope="scope">
          <el-button type="danger" size="small" icon="el-icon-delete" @click="remove(scope.row.tag)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-collapse-item>
</template>

<script>
import { PdvService } from "@/services/pdv/pdv.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "PdvClosedPost",
  computed: {
    tableList() {
      return this.tableData.filter(x => x.state === 'add');
    }
  },
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    clear() {
      this.tableData = [];
    },
    remove(tag) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-prepostagem", { id: tag }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PdvService.delete(tag)
          .then((response) => {
            const index = vm.tableData.findIndex((x) => x.tag === tag);
            vm.$bus.$emit("pdv.removed", vm.tableData[index]);
            vm.tableData[index].state = 'remove';
            this.$message({
              type: "success",
              duration: 5000,
              message: "Pré-postagem removida com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    add(data) {
      this.tableData.push(data);
    },
  },
}
</script>